"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _notifications = require("@package/notifications");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _Notification = _interopRequireDefault(require("./Notification"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

function Notifications() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var notifications = (0, _reactRedux.useSelector)(_notifications.selectNotifications);

  function handleCloseByIndex(uuid) {
    dispatch((0, _notifications.close)(uuid));
  }

  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['content']
  }, notifications.map(function (notification) {
    return /*#__PURE__*/_react["default"].createElement(_Notification["default"], Object.assign({
      key: notification['uuid']
    }, notification, {
      onClose: handleCloseByIndex
    }));
  }))), document.querySelector('#notification'));
}

var _default = Notifications;
exports["default"] = _default;